/*
 * @Description: 成功案例骨架屏
 * @Author: liuzhezhe
 * @Date: 2023-06-29 13:38:47
 * @LastEditors: liuzhezhe
 * @LastEditTime: 2024-03-05 16:44:15
 */
import React, { useState, useEffect } from 'react'
import styles from './index.scss'

const VideoSkeletons = (props) => {
  const [state] = useState([1, 2, 3, 4])

  useEffect(() => {

  }, [])

  return (
    <div className={styles['order-skeletons']}>
      {state.map(item => (
        <div className={styles['order-item']} key={item}>
          <div className={styles['skeletons']}></div>
          {/* <div className={styles['skeletons']}></div> */}
          {/* <div className={styles['skeletons']}></div> */}
        </div>
      ))}
    </div>
  )
}

export default VideoSkeletons
